import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Select, MenuItem, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setUserDetailsData } from '../../../redux/userDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { refreshAuthenticatedUser } from '../../../services/authenticatedUser';
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/users/updateUserName.css';

export const UpdateUserName = (props) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState(null);
    const userDetailsData = useSelector((state) => state.UserDetailsData);
    const authenticatedUser = useSelector((state) => state.AuthenticatedUser);

    const [roles, setRoles] = useState([]);

    const { modifyName, setModifyName } = props;

    const fetchRoles = useCallback(async () => {
        try {
            const response = await axios.get('role');
            if (response.status === 200 || response.status === 201) {
                setRoles(response.data);
            }
        } catch (error) {
            console.error('Error fetching roles:', error);
            CustomErrorLogger(error, 'fetch roles in UpdateUserName');
            setErrMsg(error.message);
        }
    }, []);

    useEffect(() => {
        fetchRoles();
    }, [fetchRoles]);

    const formik = useFormik({
        initialValues: {
            first_name: userDetailsData.first_name || '',
            last_name: userDetailsData.last_name || '',
            email: userDetailsData.email || '',
            role_id: userDetailsData?.role?.id || '',
        },
        validationSchema: Yup.object().shape({
            first_name: Yup.string().required(t('isRequired')),
            last_name: Yup.string().required(t('isRequired')),
            email: Yup.string().email(t('invalidEmail')).required(t('isRequired')),
            role_id: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`user/user_name/${id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier le nom et le rôle de l'utilisateur" }));
                    dispatch(setUserDetailsData({
                        ...userDetailsData,
                        first_name: response?.data?.first_name,
                        last_name: response?.data?.last_name,
                        role: response?.data?.role,
                        email: response?.data?.email
                    }));
                    if (id === authenticatedUser?.id) {
                        await refreshAuthenticatedUser(dispatch);
                    }
                    setModifyName(false);
                }
            } catch (error) {
                console.error('Error updating user name:', error);
                setErrMsg(error.response?.data?.message || error.message);
                CustomErrorLogger(error, 'error updating user in UpdateUserName');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors, setFieldValue } = formik;

    return (
        <Dialog open={modifyName} fullWidth>
            <Box onClick={() => setModifyName(false)} className='updateUserName_icon_text'>
                <Typography className='updateUserName_title'>{t("Modifier le nom et le rôle de l'utilisateur")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateUserName_close_icon' />
            </Box>
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateUserName_dialog_content' >
                    <Box className="updateUserName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateUserNameInputTitle">{t('Prénom')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.first_name}
                            className='updateUserName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="first_name"
                            error={touched.first_name && Boolean(errors.first_name)}
                            helperText={touched.first_name && errors.first_name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateUserName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateUserNameInputTitle">{t('Nom')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.last_name}
                            className='updateUserName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="last_name"
                            error={touched.last_name && Boolean(errors.last_name)}
                            helperText={touched.last_name && errors.last_name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateUserName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateUserNameInputTitle">{t('email')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.email}
                            className='updateUserName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="email"
                            error={touched.email && Boolean(errors.email)}
                            helperText={touched.email && errors.email}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className='updateUserName_helper_selct_box'>
                        <FormHelperText id="outlined-weight-helper-text" className="updateUserNameInputTitle">{t('Role')}</FormHelperText>
                        <Select
                            className={`updateUserName_select_metier`}
                            value={values?.role_id || ''}
                            onChange={(e) => {
                                handleChange(e);
                                setFieldValue('role_id', e.target.value);
                            }}
                            onBlur={handleBlur}
                            name="role"
                            error={touched.role_id && Boolean(errors.role_id)}
                        >
                            {roles && roles?.map((role) => (
                                <MenuItem
                                    key={role.id} className='updateUserName_select_metier_item' value={role.id}>
                                    {role.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {touched.role_id && errors.role_id && (
                            <FormHelperText error className='updateUserName_select_helper'>{errors.role_id}</FormHelperText>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions className='updateUserName_dialog_actions'>
                    <Button className='updateUserName_button_annuler' onClick={() => setModifyName(false)}>{t('Annuler')}</Button>
                    <Button className='updateUserName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};